import { checkClassesOnBody } from '@utils/trial-check';

export class Buybox {

  handlePdaBuyboxScroll() {
    const pdaBuybox = (<HTMLElement>document.querySelector('.pda-side .pda-cta-box')),
        pdaEntryContent = (<HTMLElement>document.querySelector('.pda-entry-content > .blk')),
        header = (<HTMLElement>document.querySelector('header.head')),
        dynContentBeforePricebox = (<HTMLElement>document.querySelector('.dynamic-generic-content[data-name="pda-before-pricebox"]'));

    if (!header?.offsetHeight) return;
    let topOffset = pdaEntryContent.getBoundingClientRect().top + window.scrollY - (header.offsetHeight + 40);

    let windowWidth: number = window.innerWidth;
    //Only scroll if viewport >= 992px, no dynamic content is present before pricebox and no reco/marketing content is present after pricebox and pricebox height is smaller than viewport height - header

    // TODO-PDA: remove after ABC Test
    const isPdaTrial = checkClassesOnBody(["pda-trial-b", "pda-trial-c"]);


    let scrollingActive: boolean =
        windowWidth >= 992
        && (!dynContentBeforePricebox || dynContentBeforePricebox.offsetHeight == 0)
        && !document.querySelector('.pda-side .pda-cta-box ~ *')
        && pdaBuybox.offsetHeight < window.innerHeight - topOffset
        && !isPdaTrial;

    if(scrollingActive) {
      pdaBuybox.style.marginBottom = '0';
    }

    window.addEventListener('resize', function () {
      windowWidth = window.innerWidth;
      scrollingActive =
          windowWidth >= 992
          && (!dynContentBeforePricebox || dynContentBeforePricebox.offsetHeight == 0)
          && !document.querySelector('.pda-side .pda-cta-box ~ *')
          && pdaBuybox.offsetHeight < window.innerHeight - topOffset

      if (!scrollingActive) {
        pdaBuybox.style.transform = 'translateY(0px)';
      }
    })

    function scrollBuybox() {
      const scrollY = window.scrollY,
          buyboxHeight = pdaBuybox.offsetHeight,
          pdaEntryContentHeight = pdaEntryContent.offsetHeight,
          maxTopOffset = pdaEntryContentHeight - buyboxHeight;

      topOffset = pdaEntryContent.getBoundingClientRect().top + window.scrollY - (header.offsetHeight + 40);

      if (scrollingActive && buyboxHeight < window.innerHeight - topOffset) {
        if (pdaEntryContentHeight > buyboxHeight) {
          if (window.scrollY < pdaEntryContentHeight - buyboxHeight + topOffset && window.scrollY >= topOffset) {
            pdaBuybox.style.transform = 'translateY('+ ( scrollY - topOffset ) +'px)';
          } else if (window.scrollY < topOffset) {
            pdaBuybox.style.transform = 'translateY(0px)';
          } else {
            pdaBuybox.style.transform = 'translateY('+ maxTopOffset +'px)';
          }
        } else {
          pdaBuybox.style.transform = 'translateY(0px)';
        }
      }
    }
    scrollBuybox();

    if (!isPdaTrial) {
      window.addEventListener('scroll', scrollBuybox);
    }
  }

  init() {
    if(document.querySelector('.pda.pda-v3')) {
      this.handlePdaBuyboxScroll();
    }
  }

}